import type { PageMeta } from "./types";

/**
 * Identity helper for type inference. Exists so we have a single place to
 * add validation later without changing every route file.
 */
export function definePageMeta(meta: PageMeta): PageMeta {
  return meta;
}
